export default __webpack_public_path__ + "static/media/personBlue.1cd899f0.svg";